import * as React from "react";
import { ModuleLayoutStyle } from "../../../../services/playground";
import { BannerContainer } from "../../../../components/BannerContainer";
import { ProductInfoGrid3 } from "../../../LayerUI/ProductInfoViews";
import { TripleCardWrap } from "../styles.card";
const TripleCard = (props) => {
    var _a;
    const { productElement, columnNum, layoutStyle, placeholderBg, qnParams = {} } = props;
    const collect = productElement.extra.collect;
    const titleIcon = (_a = productElement.extra.titleIcon) === null || _a === void 0 ? void 0 : _a.img;
    return (React.createElement(TripleCardWrap, { href: productElement.url, onClick: () => props.onClick && props.onClick() },
        React.createElement(BannerContainer, { banner: {
                img: productElement.img,
                link: productElement.url,
            }, className: layoutStyle === ModuleLayoutStyle.Flower
                ? "flowerTriplePPCardWrap"
                : "productPictureWrap", placeholderBg: placeholderBg, qnParams: Object.assign({}, qnParams) }),
        React.createElement(ProductInfoGrid3, { columnNum: columnNum || 3, price: productElement.price, originalPrice: productElement.originPrice, name: productElement.name, titleIcon: titleIcon, collect: collect, layoutStyle: layoutStyle })));
};
export default TripleCard;
